import { useInitialLoading } from '../hooks/useInitialLoading';
import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { getAuthHeaders } from '../utils/authHeaders';

const API = process.env.REACT_APP_API_URL || 'http://localhost:8000/api';

export default function QaExportHistory() {
  const navigate = useNavigate();
  const { projectId, subprojectId, sspId } = useParams();
  const companyId = localStorage.getItem('selectedCompanyId');
  const [exports, setExports] = useState([]);
  const [loading, setLoading] = useState(true);
  const initialLoading = useInitialLoading(loading);

  const base = `${API}/companies/${companyId}/qa/projects/${projectId}/subprojects/${subprojectId}/sub-subprojects/${sspId}`;

  useEffect(() => { if (companyId) fetchExports(); }, [companyId]);

  const authFetch = async (url, opts = {}) => {
    const res = await fetch(url, { ...opts, headers: { ...getAuthHeaders(), ...(opts.headers || {}) } });
    if (res.status === 401 || res.status === 403) { navigate('/login'); return null; }
    return res;
  };

  const fetchExports = async () => {
    setLoading(true);
    const res = await authFetch(`${base}/exports`);
    if (res && res.ok) {
      const data = await res.json();
      setExports(Array.isArray(data.data) ? data.data : (Array.isArray(data) ? data : []));
    }
    setLoading(false);
  };

  const downloadExport = async (exp) => {
    const res = await authFetch(`${base}/exports/${exp.id}/download`);
    if (res && res.ok) {
      const blob = await res.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = exp.original_filename;
      a.click();
      window.URL.revokeObjectURL(url);
    }
  };

  if (!companyId) return <div style={s.page}><p>Please select a company first.</p></div>;
  if (initialLoading) return <div style={s.page}><p>Loading export history...</p></div>;

  return (
    <div style={s.page}>
      <div style={s.breadcrumb}>
        <span style={s.breadLink} onClick={() => navigate('/company/qa')}>QA Management</span>
        <span style={s.breadSep}>/</span>
        <span style={s.breadLink} onClick={() => navigate(`/company/qa/projects/${projectId}/subprojects/${subprojectId}/workspace/${sspId}`)}>Workspace</span>
        <span style={s.breadSep}>/</span>
        <span>Export History</span>
      </div>

      <h2 style={s.title}>Export History</h2>

      {exports.length === 0 ? <p style={{ color: '#999', marginTop: 16 }}>No exports yet.</p> : (
        <div style={{ display: 'flex', flexDirection: 'column', gap: 10, marginTop: 16 }}>
          {exports.map(exp => (
            <div key={exp.id} style={s.listCard}>
              <div style={{ flex: 1 }}>
                <div style={{ fontWeight: 600, fontSize: 14 }}>V{exp.version}</div>
                <div style={{ fontSize: 13, color: '#666', marginTop: 2 }}>
                  {new Date(exp.created_at).toLocaleDateString('en-US', { day: 'numeric', month: 'short', year: 'numeric' })}
                  {exp.exporter && <span> · by {exp.exporter.name}</span>}
                </div>
                <div style={{ fontSize: 12, color: '#888', marginTop: 2 }}>
                  Tickets: {(exp.ticket_ids || []).length} included
                </div>
              </div>
              <button onClick={() => downloadExport(exp)} style={s.btnPrimary}>Download</button>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}

const s = {
  page: { padding: 24, maxWidth: 1000, margin: '0 auto' },
  title: { fontSize: 22, fontWeight: 700, margin: 0 },
  breadcrumb: { fontSize: 13, color: '#888', marginBottom: 12 },
  breadLink: { color: '#3498db', cursor: 'pointer' },
  breadSep: { margin: '0 6px' },
  listCard: { background: '#fff', borderRadius: 8, padding: '14px 18px', boxShadow: '0 1px 4px rgba(0,0,0,0.06)', display: 'flex', justifyContent: 'space-between', alignItems: 'center', flexWrap: 'wrap', gap: 10 },
  btnPrimary: { padding: '8px 16px', background: '#3498db', color: '#fff', border: 'none', borderRadius: 6, cursor: 'pointer', fontSize: 13, fontWeight: 600 },
};